import { useCallback, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import type * as React from "react";
import GradientFramedLayout from "components/v3/layouts/GradientFramedLayout";
import PageTitle from "utils/PageTitle";
import { COLORS } from "components/v3/Theme/colors";
import { PATHS } from "constants/pathConstants";
import HeroSection from "./HeroSection";
import ComparisonSection from "./ComparisonSection";
import GuidanceCallout from "./GuidanceCallout";
import HowItWorksSection from "./HowItWorksSection";
import GetStartedSection from "./GetStartedSection";
import FaqAccordions from "./FaqAccordions";
import DisclaimerSection from "./DisclaimerSection";

const CologuardLaunchPage: React.FC = () => {
  const history = useHistory();
  const comparisonSectionRef = useRef<HTMLDivElement | null>(null);

  PageTitle("Cologuard");

  const handleLearnMore = useCallback(() => {
    comparisonSectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }, []);

  const handleContinueToRelease = useCallback(() => {
    history.push(PATHS.COLOGUARD_ACKNOWLEDGEMENT_PAGE);
  }, [history]);

  return (
    <GradientFramedLayout showFooter showHeader={false}>
      <Box
        sx={{
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          gap: { md: 8, xs: 6 },
          marginX: "auto",
          maxWidth: 1120,
          minWidth: 0,
          pb: { md: 8, xs: 6 },
          pt: { md: 4, xs: 3 },
          px: { md: 3, xs: 2 },
          width: "100%"
        }}
      >
        <Box
          onClick={() => history.push(PATHS.YOUR_NEXT_STEPS)}
          sx={{
            alignItems: "center",
            alignSelf: "flex-start",
            cursor: "pointer",
            display: "flex",
            gap: { lg: 1.5, xs: 0.5 },
            width: "fit-content"
          }}
        >
          <ArrowBack sx={{ color: COLORS.DARK_GRAY, fontSize: 20 }} />
          <Typography variant="body_strong_dark_gray">
            Back to Your Next Steps
          </Typography>
        </Box>

        <HeroSection onLearnMore={handleLearnMore} />

        <Box
          ref={comparisonSectionRef}
          sx={{ display: "flex", flexDirection: "column", gap: 3 }}
        >
          <ComparisonSection />
          <GuidanceCallout />
        </Box>
        <HowItWorksSection>
          <GetStartedSection onContinue={handleContinueToRelease} />
        </HowItWorksSection>
        <FaqAccordions />
        <DisclaimerSection />
      </Box>
    </GradientFramedLayout>
  );
};

export default CologuardLaunchPage;
